const actionTypes = {
  ADD_ADDRESS: "ADD_ADDRESS",
  UPDATE_ADDRESS: "UPDATE_ADDRESS",
  FETCH_ADDRESS: "FETCH_ADDRESS",
  DELETE_ADDRESS: "DELETE_ADDRESS",
};

export { actionTypes };
